import { X } from "@/icons/X.tsx";
import React from "react";

interface XShareProps {
  text?: string;
  url?: string;
  hashtags?: string[];
  via?: string;
  onError?: () => void;
}

export const XShareButton: React.FC<XShareProps> = ({
  text,
  url,
  hashtags = [],
  via,
  onError,
}) => {
  const handleShare = () => {
    try {
      const params = new URLSearchParams();

      if (text) {
        params.append("text", text);
      }

      if (url) {
        params.append("url", url);
      }

      if (hashtags.length > 0) {
        params.append("hashtags", hashtags.join(","));
      }

      if (via) {
        params.append("via", via);
      }

      const twitterUrl = `https://twitter.com/intent/tweet?${params.toString()}`;

      // Open in a new window with specific dimensions (Twitter's recommended size)
      const width = 550;
      const height = 420;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;

      const shareWindow = window.open(
        twitterUrl,
        "Share on Twitter",
        `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no`,
      );

      if (shareWindow) {
        shareWindow.focus();
      } else if (onError) {
        onError();
      }
    } catch (error) {
      if (onError) {
        onError();
      }
    }
  };

  return (
    <button
      onClick={handleShare}
      className="bg-black fill-white rounded-full w-8 h-8 flex items-center justify-center"
      aria-label="Share on X (Twitter)"
    >
      <X size={18} />
    </button>
  );
};
